import Vue from 'vue'
import ElementUI from 'element-ui';
import './plugins/element.js';
import router from './router.js'
import App from './App.vue'
import i18n from './i18n';
import { Picker, Popup } from 'vant';


Vue.config.productionTip = false;
Vue.use(ElementUI).use(Picker).use(Popup);


Vue.filter('json', value => { return JSON.stringify(value, null, 2) } )

new Vue({
  render: h => h(App),
  router,
  i18n,
}).$mount('#app')
